import ProfileSummary, {
  ProfileSummaryProps,
} from 'components/ProfileSummary/ProfileSummary';

export type {ProfileSummaryProps};
export default ProfileSummary;
